import React, { memo } from 'react';
import { ContentLayout } from 'bv-components';
import LegacyHomeComponents from 'apps/legacy_home_components';
import { Banners, HomeComponents } from './components';

export default memo(() => (
  <ContentLayout showTabs>
    <Banners />
    <HomeComponents />
    <LegacyHomeComponents />
  </ContentLayout>
));
